import { selectCurrentlyApplicableContentTypes } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectDisplaySettings } from '~src/spacesPlatform/selectors/DisplaySettingsSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { SpaceInfo, SpaceType, SubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { getAppStore } from '../../app/AppStore';
import { BaseTelemetryEvent, ValidTelemetryEvent } from '../../commonInfra/services/Telemetry';
import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { Omit } from '../../ts/helpers/TypescriptHelpers';
import { DisplayMode } from '../../ts/ServerApi/types/ISessionInfo';
import { ExplorerEvent } from './TelemetryEvents';

export type ExplorerEventContentType = ExplorableItemType | 'mixed';

export type ExplorerEventInfo =
  {
    space: SpaceType;
    subspace: SubspaceName;
    contentType: ExplorerEventContentType;
    displayMode: DisplayMode;
  };

// I'm not sure why we need to '& BaseTelemetryEvent' but it makes the compiler happy
type EventWithoutExplorerEventInfo<T extends ExplorerEvent> = Omit<T, keyof ExplorerEventInfo> & BaseTelemetryEvent;

/**
 * populates the space, subspace and contentType information for telemetry events
 */
export function CreateExplorerEvent<T extends ExplorerEvent>(
  event: ValidTelemetryEvent<EventWithoutExplorerEventInfo<T>>
): ValidTelemetryEvent<T> {

  const appState = getAppStore().getState();
  const spaceInfo: SpaceInfo = selectSpaceInfo(appState);
  const contentTypes: ReadonlyArray<ExplorableItemType> = selectCurrentlyApplicableContentTypes(appState);
  const displayMode: DisplayMode = selectDisplaySettings(appState).explorerDisplayMode;

  const explorerEvent = {
    space: spaceInfo.spaceType,
    subspace: spaceInfo.subspaceName,
    contentType: contentTypes.length !== 1 ? 'mixed' : contentTypes[0],
    displayMode: displayMode,
    ...(event as object)
  } as ValidTelemetryEvent<T>;

  return explorerEvent;
}
